import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
export const PROGRAM_FEATURES_OBJ = {
    raves: "raves",
    cyc: "cyc",
    incentives: "incentives",
    tasker: "tasker",
    liteRaves: "liteRaves",
};
export const PROGRAM_FEATURES = Object.values(PROGRAM_FEATURES_OBJ);
export const createProgram = (data) => {
    if (!assertProgram(data, "save")) {
        throw new Error("Program.save failed");
    }
    return data;
};
export function assertProgramFeatures(features) {
    if (!Array.isArray(features)) {
        throw new Error("Program.features must be an array");
    }
    for (const feature of features) {
        if (!PROGRAM_FEATURES.includes(feature)) {
            throw new Error(`Program.features must only contain valid features: ${PROGRAM_FEATURES.join(", ")}`);
        }
    }
}
export function assertRegions(regions) {
    if (!Array.isArray(regions)) {
        throw new Error("Program.regions must be an array");
    }
    for (const region of regions) {
        if (typeof region !== "string") {
            throw new Error("Program.regions must only contain strings");
        }
    }
}
export const assertProgram = (data, mode = "load") => {
    if (!data || typeof data !== "object") {
        throw new Error("Program must be an object");
    }
    const program = data;
    // Required fields based on mode
    const requiredFields = mode === "save"
        ? ["features", "regions", "name"]
        : ["id", "features", "regions", "name", "createdAt", "modifiedAt"];
    for (const field of requiredFields) {
        if (!(field in program)) {
            throw new Error(`Program is missing required field: ${field}`);
        }
    }
    // Type checks
    if (mode === "load" && typeof program.id !== "string") {
        throw new Error("Program.id must be a string");
    }
    if (typeof program.name !== "string") {
        throw new Error("Program.name must be a string");
    }
    // Validate features and regions
    assertProgramFeatures(program.features);
    assertRegions(program.regions);
    // Timestamp validation based on mode
    // if (mode === "load") {
    //   if (!(program.createdAt instanceof DateTime)) {
    //     throw new Error("Program.createdAt must be a DateTime");
    //   }
    //   if (!(program.modifiedAt instanceof DateTime)) {
    //     throw new Error("Program.modifiedAt must be a DateTime");
    //   }
    // } else {
    //   if (program.createdAt && !(program.createdAt instanceof DateTime)) {
    //     throw new Error(
    //       "Program.createdAt must be a DateTime or FieldValue.serverTimestamp()",
    //     );
    //   }
    //   if (program.modifiedAt && !(program.modifiedAt instanceof DateTime)) {
    //     throw new Error(
    //       "Program.modifiedAt must be a DateTime or FieldValue.serverTimestamp()",
    //     );
    //   }
    // }
    return true;
};
export const createProgramConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(program) {
        if (!assertProgram(program, "save")) {
            throw new Error("Program.save failed");
        }
        const { id, ...programWithoutId } = program;
        const data = {
            ...programWithoutId,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(program.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(program.modifiedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const program = {
            ...data,
            id: snapshot.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
        };
        if (!assertProgram(program, "load")) {
            throw new Error("Program.load failed");
        }
        return program;
    },
});
//# sourceMappingURL=Program.js.map